import { Component, Optional } from '@angular/core';
import { WorkspaceView } from 'components/core/workspace/workspace.component';
import { PanelComponent } from 'components/layout/panel/panel.component';
import { OrderComponent } from 'components/sale/order.component';
import { OrderModel } from 'models/generated/Entities.GormCrm.Order';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { Pipes } from 'modules/pipes';
import { DataTracking, RefreshService } from 'services/data-tracking';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { ProductService } from 'services/product.service';
import { SalesService } from 'services/sales.service';
import { ProductPlanService } from 'services/productplan.service';

@Component({
	selector: 'order-pipeline',
	templateUrl: './order-pipeline.component.html',
	providers: [DataTracking, RefreshService],
	imports: [Layout, ListView, Pipes]
})
@ComponentUrl('order-pipeline')
export class OrderPipelineComponent {

	orders: OrderModel[] = [];
	selectedOrder?: OrderModel;
	loading = true;

	constructor(
		private readonly navigation: NavigationService,
		public readonly salesService: SalesService,
		private readonly productService: ProductService,
		private readonly tracker: DataTracking,
		private readonly parentView: WorkspaceView,
		private readonly refreshService: RefreshService,
		@Optional() public parent?: PanelComponent) {

		if (parent) parent.refresh = refreshService;

		this.reloadList();
		refreshService.onRefresh.subscribe(() => { this.reloadList(); });
	}

	async reloadList(): Promise<void> {
		this.loading = true;

		const [orders, products] = await Promise.all([
			this.salesService.getUndeliveredOrders(this.tracker),
			this.productService.getAllActiveProducts(false)
		]);

		const productVariantsById = new Map(products.flatMap(product => product.productVariants).map(variant => [variant.id!, variant]));
		for (const orderLine of orders.flatMap(o => o.orderLines)) {
			if (!orderLine.productVariant) orderLine.productVariant = productVariantsById.get(orderLine.productVariantId!);
		}

		this.orders = orders;
		this.loading = false;
		this.refreshService.refreshAvailable();
	}

	getAcv(order: OrderModel): number {
		return order.orderLines.reduce((sum, orderLine) => {
			if (!orderLine.productVariant) return sum;
			const period = this.productService.getVariantPeriod(orderLine.productVariant);
			return sum + (period != null ? orderLine.totalPrice / (period / 12) : 0);
		}, 0);
	}

		getDeliveredCount(order: OrderModel): number {
		return order.orderLines.flatMap(l => l.productPlans).filter(plan => plan.deliveryDate).length;
	}

	getTotalCount(order: OrderModel): number {
		return order.orderLines.flatMap(l => l.productPlans).length;
	}


	displayOrder(order: OrderModel) {
		this.selectedOrder = order;
		this.navigation.openRelativeView(this.parentView.component!, 'order-pipeline', OrderComponent).then(view => {
			view.orderId = order.id;
		});
	}
}
